import { storage } from 'common/storage';

import {
  BottomPinnedLegendAction,
  BottomPinnedLegendActionTypes,
  PINNED_WIDGET_LEGEND_STORAGE_KEY,
} from './actions';

export const bottomPinnedLegendReducer = (
  state: boolean | undefined,
  action: BottomPinnedLegendAction,
) => {
  if (state === undefined) {
    return storage.local.getItem(PINNED_WIDGET_LEGEND_STORAGE_KEY) ?? false;
  }

  switch (action.type) {
    case BottomPinnedLegendActionTypes.Set: {
      return action.payload;
    }
  }

  return state;
};
